import { handleActions } from "redux-actions";
import { SCOPE_BRAND_SET, WATERMARKING } from "constants/action-types";
import { initialBaseState, fetchActions, IFetchStoreState } from "./base-reducers";

export interface IDataAttribute {
    key: string;
    schemaType?: string;
}

export interface IWatermarking {
    active?: boolean;
    text?: string;
    dataAttributes?: IDataAttribute[];
    textColor?: string;
    textOpacity?: number;
    backgroundColor?: string;
    backgroundOpacity?: number;
    previewImage?: string;
}

export const watermarking = handleActions<IFetchStoreState<IWatermarking>, IWatermarking>(
    {
        [SCOPE_BRAND_SET]: () => initialBaseState,
        ...fetchActions(WATERMARKING.PREVIEW),
        ...fetchActions(WATERMARKING.FETCH),
        ...fetchActions(WATERMARKING.UPDATE),
    },
    initialBaseState
);
